// extracted by mini-css-extract-plugin
module.exports = {"container":"CardsContainer_container__ozBtU","items":"CardsContainer_items__OA8l6","maxWidth":"CardsContainer_maxWidth__WMp2Z","wrap":"CardsContainer_wrap__4IcCg"};